import React from 'react';

import { SpaceBetween, Popover, StatusIndicator, Button, Box } from '@amzn/awsui-components-react-v3';

import { ValueWithLabel } from 'src/components/Utils';

export const ReceivedQuanity = ({ count = 0, show }: { count: number; show: boolean }) => {
  if (!show) {
    return null;
  }

  return (
    <ValueWithLabel
      label={
        <SpaceBetween direction="horizontal" size="xxxs">
          <Popover
            dismissButton={false}
            position="top"
            size="small"
            triggerType="custom"
            content={
              <StatusIndicator type="info">
                Quantity already received and quantity being received in the current transaction for the given MPN and
                IPN in the ASN or PO
              </StatusIndicator>
            }
          >
            <Button ariaLabel="received-qty-info" iconName="status-info" variant="icon" />
          </Popover>
          <Box variant="awsui-key-label">Received Qty.</Box>
        </SpaceBetween>
      }
    >
      <Box margin={{ left: 'l' }}>{count}</Box>
    </ValueWithLabel>
  );
};
